module.exports = __webpack_public_path__ + "c9c5a4d59990567efabf4ee5c7d531a0.png";